import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class ViewportService {
	// Indicates whether the current viewport is considered mobile
	private isMobile = false;

	constructor() {
		// Initialize and listen to resize events
		this.checkViewport();
		window.addEventListener('resize', () => this.checkViewport());
	}

	/**
	 * Checks the current window width and updates the isMobile flag.
	 * The mobile breakpoint is set to 844px.
	 */
	private checkViewport(): void {
		this.isMobile = window.innerWidth < 844;
	}

	/**
	 * Returns whether the current viewport is mobile.
	 * Can be used to adapt components based on screen size.
	 */
	isMobileView(): boolean {
		return this.isMobile;
	}
}
